module.exports = __webpack_public_path__ + "images/smartphone-screen-3_6f879b6ccbe918b6a6eba6b05192f5a4.png";